[
  { "id": "teal", "title": "Teal", "hex": "#008080" },
  { "id": "navy", "title": "Navy", "hex": "#000080" },
  { "id": "black", "title": "Black", "hex": "#000000" },
  { "id": "maroon", "title": "Maroon", "hex": "#800000" },
  { "id": "green", "title": "Green", "hex": "#008000" },
  { "id": "silver", "title": "Silver", "hex": "#c0c0c0" }
]
